















import { ConferenceDoctorMemberRestControllerApi, Configuration, UserForm } from '@/types/api-docs'
import Vue from 'vue'
import PasswordForm from '@/components/PasswordForm.vue'
import Loading from '@/components/Loading.vue'

const memberApi = new ConferenceDoctorMemberRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

export interface DataType {
  pageName: string
  breadcrumbs: unknown[]
  userForm: UserForm
  passwordValid: boolean
  loading: boolean
}

export default Vue.extend({
  name: 'ChangePassword',
  components: { PasswordForm, Loading },
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      userForm: { newPassword: '' },
      passwordValid: true,
      loading: false,
    }
  },
  methods: {
    async changePassword() {
      this.loading = true
      await memberApi
        .updatePassword(this.userForm)
        .then(() => {
          alert('パスワードを変更しました')
        })
        .catch(() => {
          alert('パスワード変更に失敗しました')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
})
